<template>
  <div>
    <list
      row-key="RecommendId"
      ref="list"
      unit="重大推优备忘录"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query"></template>
      <template slot="table">
        <el-table-column prop="RecommendName" label="所属项目" />
        <el-table-column prop="ProjectDate" label="项目时间">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.ProjectDate)}}</template>
        </el-table-column>
        <el-table-column prop="GdLv" label="级别" width="90" />
        <el-table-column prop="TeacherName" label="姓名" width="90" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {},
  data() {
    return {
      api: require("@/api/gd/recommend").default,
      params: {
        Status: 3,
        IsPass: 1,
      },
    };
  },
  mounted() {},
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then((res) => {
        loading.close();
      });
    },
  },
};
</script>